import { FILTERBYCATEGORY, FILTERBYSEARCH } from "./actionTypes";
import initialState from "./initialState";

const filterReducer = (state = initialState, action) => {
  switch (action.type) {
    case FILTERBYSEARCH:
      return { ...state, search: action.payload };

    case FILTERBYCATEGORY:
      return { ...state, category: action.payload };

    default:
      return { ...state };
  }
};

export default filterReducer;
